import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validationConstants, validationFunctions } from "@/utils/validationUtils";
import { App as AntApp, Button, Card, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../../../common/components/icons/AntIcon";
import { Permission } from "../../../../../common/security/enums";
import ComponentWithPermission from "../../../../auth/components/ComponentWithPermission";
import { CommissionsSettingsRank } from "../../types";
import { CommissionsSettingsRankModalForm } from "../forms/CommissionsSettingsRankModalForm";
import { CommissionsSettingsRanksTableView } from "../list/CommissionsSettingsRanksTableView";

export const CommissionsSettingsRanksListContainer = () => {
  const { t } = useTranslation();
  const { message } = AntApp.useApp();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rankToUpdate, setRankToUpdate] = useState<CommissionsSettingsRank>();

  const navigate = useNavigate();
  const keywordSearchParam = useFilterSearchParams().keyword;

  const handleSearchSubmit = (keyword: string) => {
    if (validationFunctions.validateSearchKeyword(keyword)) {
      navigate(
        {
          search: URLQuery.searchParamsToString({
            searchParams: { keyword },
          }),
        },
        { replace: true },
      );
    } else {
      message.error(
        t("validation.size", {
          min: validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
          max: validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
        }),
      );
    }
  };

  const handleCreateRank = () => {
    setRankToUpdate(undefined);
    setIsModalOpen(true);
  };

  const handleUpdateRank = (rank: CommissionsSettingsRank) => {
    setRankToUpdate(rank);
    setIsModalOpen(true);
  };

  const handleFormCancel = () => {
    setIsModalOpen(false);
    setRankToUpdate(undefined);
  };

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={<h2>{t("commissions.rank.titles.list")}</h2>}
        extra={
          <>
            <ComponentWithPermission permissions={[Permission.TOP_AGENT_COMMISSIONS_MANAGE]}>
              <Button
                className="margin-right-small"
                type="primary"
                icon={<AntIcon type="plus" />}
                onClick={handleCreateRank}
              >
                {t("commissions.rank.actions.createRank")}
              </Button>
            </ComponentWithPermission>

            <Input.Search
              style={{ width: 350 }}
              enterButton
              allowClear
              placeholder={t("commissions.rank.helpers.searchHint")}
              defaultValue={keywordSearchParam}
              onSearch={handleSearchSubmit}
            />
          </>
        }
      >
        <CommissionsSettingsRanksTableView onUpdateRank={handleUpdateRank} />
      </Card>

      <CommissionsSettingsRankModalForm rank={rankToUpdate} isOpen={isModalOpen} onFormCancel={handleFormCancel} />
    </ContentWrapper>
  );
};
